import React, { useRef, useState } from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import SearchIcon from '@mui/icons-material/Search'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import StarIconGolden from '../../assets/imgs/star-icon-golden.svg'
import SelectLocationModal from '../../modals/SelectLocationModal'
import { useEffect } from 'react'
import { getAllData, getDataById } from '../../apis/generalApis'
import FeaturedStylistCard from './Cards/FeaturedStylistCard'
import {
  Autocomplete,
  Circle,
  GoogleMap,
  LoadScript,
  Marker,
  useJsApiLoader,
} from '@react-google-maps/api'
import {
  geocodeByPlaceId,
  getLatLng,
  geocodeByAddress,
} from 'react-google-places-autocomplete'
import { Link } from 'react-router-dom'
import ServiceFilterModal from '../../modals/ServiceFilterModal'
import SubServiceFilterModal from '../../modals/SubServiceFilterModal'
import DistanceFilterDropdownModal from '../../modals/DistanceFilterDropdownModal'
import RatingsFilterModal from '../../modals/RatingsFilterModal'
import SortByFilterModal from '../../modals/SortByFilterModal'
import { ScaleLoader } from 'react-spinners'

const ClientSearch = () => {
  // const { isLoaded } = useJsApiLoader({
  //   id: 'google-map-script',
  //   googleMapsApiKey: 'AIzaSyBYrhwDLjzAji73YKhXj_xO1ODCMKwXjtk',
  // })

  const user = JSON.parse(localStorage.getItem('user'))
  let clientLocation = JSON.parse(localStorage.getItem('client_location'))
  const [isLoading, setIsLoading] = useState(false)
  const [center, setCenter] = React.useState(
    clientLocation ?? {
      lat: 48.8584,
      lng: 2.2945,
    },
  )
  const [mapCenter, setMapCenter] = React.useState({
    ...center,
  })
  const memoizedCenter = React.useMemo(() => setMapCenter(center), [center])
  const [stylists, setStylists] = useState([])
  const [initialStylists, setInitialStylists] = useState([])
  useEffect(() => {
    // getServices()
    getStylists()
    getFavouriteStylists()
  }, [])

  const getStylists = async () => {
    let body = {
      user_id: user?.id,
    }
    setIsLoading(true)
    let result = await getDataById('show-stylists', body)
    setIsLoading(false)
    if (result?.success && result?.data) {
      setStylists(result?.data)
      setInitialStylists(result?.data)
    }
  }
  const searchRef = useRef('')
  const [zipCode, setZipCode] = useState('')
  const [selectedService, setselectedService] = useState(null)
  const [selectedSubService, setSelectedSubService] = useState(null)
  const [favouriteStylists, setFavouriteStylists] = React.useState([])
  const [distanceDropdownValue, setDistanceDropdownValue] = useState(10)

  const [ratingDropdownOptions, setRatingDropdownOptions] = useState(
    new Array(0).fill({}),
  )

  const getFavouriteStylists = async () => {
    try {
      let result = await getDataById('show-favorite-stylists', {
        user_id: user?.id,
      })
      if (result?.success === true) {
        setFavouriteStylists(result?.data?.stylist)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const [selectLocationModal, setSelectLocationModal] = useState(false)
  const [
    selectedSortDropdownOption,
    setSelectedSortDropdownOption,
  ] = React.useState('')

  const handleSelectLocationModal = () => {
    setSelectLocationModal(!selectLocationModal)
  }

  useEffect(() => {
    if (zipCode) {
      let body = {
        user_id: user?.id,
        zip_code: zipCode,
      }
      filterStylists(body)
    }
  }, [zipCode])

  const filterStylists = async (body) => {
    setIsLoading(true)
    let result = await getDataById('show-stylists', body)
    setIsLoading(false)
    if (result.success === true) {
      setStylists(result?.data)
    }
  }

  const [value, setValue] = React.useState(null)

  const handleSearch = async () => {
    if (searchRef?.current?.value) {
      setStylists((prev) =>
        initialStylists?.filter((el) => {
          let name =
            el?.first_name?.toLowerCase() + el?.last_name?.toLowerCase()
          if (name?.includes(searchRef?.current?.value?.toLowerCase().replace(/ /g, ''))) {
            return el
          }
        }),
      )
    } else {
      setStylists(initialStylists)
    }
  }

  const handleEnterPress = async (e) => {
    if (e.key === 'Enter') {
      if (searchRef.current.value) {
        setIsLoading(true)
        let result = await getDataById('search-stylists', {
          query: searchRef.current.value,
        })
        setIsLoading(false)
        if (result?.success === true) {
          setStylists(result?.data)
        }
      } else {
        setStylists(initialStylists)
      }
    }
  }

  const [serviceFilterModal, setServiceFilterModal] = useState(false)

  const handleServiceFilterModal = () => {
    setServiceFilterModal((prev) => !prev)
  }

  const [subServiceFilterModal, setSubServiceFilterModal] = useState(false)

  const handleSubServiceModal = () => {
    setSubServiceFilterModal((prev) => !prev)
  }

  const [distanceFilterModal, setDistanceFilterModal] = useState(false)

  const handleDistanceFilterDropdownModal = () => {
    setDistanceFilterModal((prev) => !prev)
  }

  const [ratingsFilterModal, setRatingsFilterModal] = useState(false)

  const handleRatingsFilterModal = () => {
    setRatingsFilterModal((prev) => !prev)
  }

  const [sortByFilterModal, setSortByFilterModal] = useState(false)

  const handleSortByFilterModal = () => {
    setSortByFilterModal((prev) => !prev)
  }

  React.useEffect(() => {
    if (value?.value?.place_id) {
      geocodeByPlaceId(value?.value?.place_id)
        .then((results) => {
          const latLng = getLatLng(results[0])
            .then((coordinates) => {
              setCenter(coordinates)
            })
            .catch((err) => console.log(err))
        })
        .catch((error) => console.error(error))
    }
  }, [value])

  return (
    <div className="client-search">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="row m-0 py-2 border-primary-btn">
        <div className="col-12 col-sm-12 col-md-6 d-flex align-items-center">
          <div className="client-search-input-wrapper w-100 px-0 px-lg-5">
            <div className="h-100 input-locaiton-wrapper py-2 d-flex align-items-center justify-content-between">
              <div className="search-input h-100 d-flex align-items-center w-50">
                <SearchIcon className="search-icon" />
                <input
                  type="text"
                  className="fs-18"
                  placeholder="Search for Providers"
                  ref={searchRef}
                  onChange={handleSearch}
                  // onKeyDown={handleEnterPress}
                />
              </div>
              <div
                className="location-btn px-4 py-1 pointer"
                onClick={handleSelectLocationModal}
              >
                <p className="m-0 text-white fs-18">
                  <LocationOnIcon
                    className="location-icon"
                    style={{ width: '14px' }}
                  />{' '}
                  {value ? value.label : 'Select Location'}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6">
          <div className="row g-0 mt-0">
            <div className="col-9 row flex-nowrap overflow-auto m-0 gx-2">
              <div
                className="col-4 d-flex"
                style={{ width: '7rem' }}
                onClick={handleServiceFilterModal}
              >
                <div className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100">
                  <div className="sort-dropdown d-flex flex-wrap justify-content-evenly align-items-center w-100 px-1">
                    <p className="fs-18 m-0">
                      {selectedService?.name ?? 'Service'}
                    </p>
                    <p className="m-0 color-primary fw-bold d-flex align-items-center">
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-4 d-flex" style={{ width: '9rem' }}>
                <div
                  className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100"
                  onClick={handleSubServiceModal}
                >
                  <div className="sort-dropdown d-flex flex-wrap justify-content-evenly align-items-center w-100 px-1">
                    <p className="fs-18 m-0">
                      {selectedSubService?.title ?? 'Sub-service'}
                    </p>
                    <p className="m-0 color-primary fw-bold d-flex align-items-center">
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-4 d-flex" style={{ width: '10rem' }}>
                <div className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100">
                  <div
                    onClick={handleDistanceFilterDropdownModal}
                    className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center w-100 px-2"
                  >
                    <p className="fs-18 m-0">Distance</p>
                    <p className="m-0 color-primary fw-bold d-flex align-items-center">
                      {distanceDropdownValue} miles
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-4 d-flex" style={{ width: '12rem' }}>
                <div
                  className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100"
                  onClick={handleRatingsFilterModal}
                >
                  <div className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center w-100 px-2">
                    <p className="fs-18 m-0">Ratings</p>
                    <p className="fs-12 m-0 color-primary fw-bold d-flex align-items-center">
                      <div className="d-flex">
                        <p className="color-primary">
                          Select Rating
                          {/* {ratingDropdownOptions?.length > 0 && (
                            <span className="d-flex align-items-center gap-1 fs-6">
                              {ratingDropdownOptions?.length}
                              <img
                                src={StarIconGolden}
                                alt="Rating Icon"
                                height={15}
                                className="p-0"
                                // key={index}
                              />
                            </span>
                          )} */}
                        </p>
                        {/* {ratingDropdownOptions?.length + 1} */}
                      </div>
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-4 d-flex" style={{ width: '7rem' }}>
                <div
                  className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center w-100"
                  onClick={handleSortByFilterModal}
                >
                  <div className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center w-100 px-2">
                    <p className="fs-18 m-0">Sort By</p>
                    <p className="m-0 color-primary fw-bold d-flex align-items-center">
                      {/* {selectedSortDropdownOption?.label} */}
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex align-items-center justify-content-between h-100 flex-wrap gap-2 px-2">
                <span
                  className="fs-15 fw-bold color-primary pointer"
                  onClick={() => {
                    filterStylists({
                      user_id: user?.id,
                      subservice: selectedSubService?.title,
                      rating: ratingDropdownOptions?.length,
                      services: selectedService?.name,
                      distance: distanceDropdownValue,
                      sort_value: selectedSortDropdownOption?.value,
                    })
                  }}
                >
                  Apply Filters
                </span>
                <span
                  className="fs-15 fw-bold pointer"
                  onClick={() => {
                    setselectedService(null)
                    setSelectedSubService(null)
                    setRatingDropdownOptions(new Array(0).fill({}))
                    setDistanceDropdownValue(10)
                    setSelectedSortDropdownOption('')
                    setZipCode('')
                    setValue(null)
                    getStylists()
                  }}
                >
                  Clear Filters
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="row m-0"
        style={{
          height: 'calc(100vh - 153px)',
          overflow: 'auto',
        }}
      >
        <div
          className="col-12 col-sm-12 col-md-6 h-100"
          style={{ border: '1px solid black', overflow: 'auto' }}
        >
          <div
            className="row gx-2 gy-3"
            style={{
              maxHeight: 'calc(100vh - 140px)',
              overflow: 'auto',
              padding: '1rem 0',
            }}
          >
            {stylists?.length === 0 && <h3>No stylists found.</h3>}
            {stylists &&
              stylists?.map((stylist, index) => (
                <div className="col-12 col-sm-6 col-md-12 col-lg-6" key={index}>
                  <FeaturedStylistCard
                    stylist={stylist}
                    action={
                      favouriteStylists?.find((el) => el?.id === stylist?.id)
                        ? 'remove-favourite'
                        : 'add-favourite'
                    }
                    isFavourite={
                      favouriteStylists?.find((el) => el?.id === stylist?.id)
                        ? true
                        : false
                    }
                    getFavouriteStylists={getFavouriteStylists}
                    getStylists={getStylists}
                  />
                </div>
              ))}
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 h-100 p-0">
          {/* <LoadScript googleMapsApiKey="AIzaSyBYrhwDLjzAji73YKhXj_xO1ODCMKwXjtk"> */}
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            center={mapCenter}
            zoom={10}
            options={{
              fullscreenControl: false,
              streetViewControl: false,
              mapTypeControl: false,
            }}
          >
            <Marker
              position={mapCenter}
              opacity={1}
              visible={true}
              zIndex={99999}
            ></Marker>
            <Circle
              center={mapCenter}
              radius={30000}
              options={{
                strokeColor: '#14b1e4',
                fillColor: '#14b1e4',
                fillOpacity: 0.16,
                strokeOpacity: 0.16,
              }}
            />
          </GoogleMap>
          {/* </LoadScript> */}
          {/* <div className="map-area position-relative h-100">
            <div className="map-area position-relative"></div>
          </div> */}
        </div>
      </div>
      <SelectLocationModal
        handleSelectLocationModal={handleSelectLocationModal}
        selectLocationModal={selectLocationModal}
        mapCenter={mapCenter}
        setCenter={setCenter}
        value={value}
        setValue={setValue}
        setZipCode={setZipCode}
        center={center}
      />
      <ServiceFilterModal
        handleServirFilterModal={handleServiceFilterModal}
        serviceFilterModal={serviceFilterModal}
        selectedService={selectedService}
        setSelectedService={setselectedService}
      />
      <SubServiceFilterModal
        handleSubServirFilterModal={handleSubServiceModal}
        subServiceFilterModal={subServiceFilterModal}
        selectedSubService={selectedSubService}
        setSelectedSubService={setSelectedSubService}
      />
      <DistanceFilterDropdownModal
        distanceFilterModal={distanceFilterModal}
        handleDistanceFilterDropdownModal={handleDistanceFilterDropdownModal}
        distanceDropdownValue={distanceDropdownValue}
        setDistanceDropdownValue={setDistanceDropdownValue}
      />
      <RatingsFilterModal
        handleRatingsFilterModal={handleRatingsFilterModal}
        ratingsFilterModal={ratingsFilterModal}
        ratingDropdownOptions={ratingDropdownOptions}
        setRatingDropdownOptions={setRatingDropdownOptions}
      />
      <SortByFilterModal
        handleSortByFilterModal={handleSortByFilterModal}
        sortByFilterModal={sortByFilterModal}
        selectedSortDropdownOption={selectedSortDropdownOption}
        setSelectedSortDropdownOption={setSelectedSortDropdownOption}
      />
    </div>
  )
}

export default ClientSearch
